import firebase from 'firebase';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: "AIzaSyCcL6iP20B3-GBVWrPNeLLaNyBK-szQjK8",
  authDomain: "gcc-493jack.firebaseapp.com",
  databaseURL: "https://gcc-493jack.firebaseio.com",
  projectId: "gcc-493jack",
  storageBucket: "gcc-493jack.appspot.com",
  messagingSenderId: "478204313807",
  appId: "1:478204313807:web:855541105f453eee28b7ba",
  measurementId: "G-ZG127W567G"
};
// Initialize Firebase
firebase.initializeApp(config);
// firebase.analytics();

export default firebase;
